import React from 'react';

import { ClassMap, makeMuiStyles, useCommonStyles, usePalette } from '@styles';
import { createStrings } from '@utils/local';
import clsx from 'clsx';
import Color from 'color';

const strings = createStrings({
  ja: {
    error: 'エラー',
    success: '完了',
  },
});

const useStyles = makeMuiStyles((theme, common) => ({
  container: {
    ...common.middleText,
    ...common.flexCenter,
    padding: '12px 12px',
    color: theme.palette.secondary.contrastText,
    backgroundColor: theme.palette.primary.main,
    userSelect: 'none',
    '&$error': {
      backgroundColor: Color(theme.palette.primary.main).alpha(0.4).toString(),
    },
  },
  error: {},
}));

export interface ProgressBarProps {
  classes?: ClassMap<'container' | 'inner'>;
  progress?: number;
  loading?: boolean;
  error?: boolean;
  success?: boolean;
  loadingText?: (progress: number) => string;
  errorText?: string;
  successText?: string;
  onReset?: () => void;
}

export const ProgressBar: React.FC<ProgressBarProps> = (props) => {
  const classes = {
    ...useCommonStyles(),
    ...useStyles(),
  };

  const palette = usePalette();

  const {
    classes: customClasses = {},
    progress = 0,
    loading = false,
    error = false,
    success = false,
    loadingText = () => '',
    errorText = strings.error,
    successText = strings.success,
    onReset,
  } = props;

  const lightColor = Color(palette.primary.main).alpha(0.4);
  const linearGradient = `linear-gradient(to right, ${palette.primary.main} ${
    progress * 100
  }%, ${lightColor} ${progress * 100}%)`;

  return (
    <div
      className={clsx(
        classes.container,
        error && classes.error,
        error && classes.baseButton,
        customClasses.container,
      )}
      style={loading ? { background: linearGradient } : undefined}
      onClick={error ? onReset : undefined}
    >
      {loading && !error && loadingText(progress)}
      {error && errorText}
      {success && successText}
    </div>
  );
};
